import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Retour à l'accueil", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_base = _resolveComponent("icon-base")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.isHome)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/",
            class: "back-link"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon_base, {
                "icon-name": "ArrowLeft",
                "icon-label": "retour",
                width: "16",
                height: "16",
                class: "icon"
              }),
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.icon)
      ? (_openBlock(), _createBlock(_component_icon_base, {
          key: 0,
          "icon-name": _ctx.icon,
          "icon-label": _ctx.title,
          width: "24",
          height: "24",
          class: "icon"
        }, null, 8, ["icon-name", "icon-label"]))
      : _createCommentVNode("", true)
  ]))
}